import { FC } from 'react';
import { PageSizer } from './PageSizer';
import { SmallBackground } from '../background/SmallBackground';
import { Breadcrumbs, NavPage } from './Breadcrumbs';

export enum PageHeaderSize {
  SMALL,
  LARGE
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  imageUrl?: string;
  breadcrumbs?: NavPage[];
  size?: PageHeaderSize;
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  subtitle,
  description,
  imageUrl,
  breadcrumbs,
  size = PageHeaderSize.SMALL
}) => {
  let headerHeight: number;

  switch (size) {
    case PageHeaderSize.SMALL:
      headerHeight = 150;
      break;
    case PageHeaderSize.LARGE:
      headerHeight = 225;
      break;
  }

  return (
    <div>
      <div className="w-full relative" style={{ height: headerHeight }}>
        {imageUrl && <SmallBackground className="w-full h-full absolute top-0 z-[2]" imageUrl={imageUrl} />}
        <PageSizer className="z-10 relative h-full">
          <div className="h-full flex flex-col justify-center max-w-[50%]">
            <div className="text-4xl text-primary-800">{title}</div>
            {subtitle && <div className="text-2xl text-primary-800">{subtitle}</div>}
            {description && <div className="mt-2">{description}</div>}
          </div>
        </PageSizer>
      </div>
      {breadcrumbs && (
        <div className="bg-white">
          <PageSizer>
            <Breadcrumbs pages={breadcrumbs} />
          </PageSizer>
        </div>
      )}
    </div>
  );
};
